<template>
	<div :id="domId" class="sTradingviewView"></div>
</template>
<script>
import { widget } from '/public/charting_library';
import datafeeds from "./static/datafees.js";
import config from "./config/index.js";
import tabsConfig from "./config/tabs.js";
import { webSocketMixin } from "./mixin/webSocket.js";
import { getLang } from '@/utils/validate'
import klineApi from "@/api/kline";
import { EventBus } from '@/utils/event-bus'

export default {
	name: "Tradingview",
	mixins: [webSocketMixin],
	props: {
		//产品
		// symbol: {
		// 	type: String,
		// 	default() {
		// 		return "HBbtcusdt";
		// 	},
		// },
		//Dom元素id
		domId: {
			type: String,
			default: function () {
				return "tradeView";
			},
		},
		//参数
		marketName: {
			type: String,
			default: function () {
				return "";
			},
		},
		// 请求id
		marketId: {
			type: [String, Number],
			default: function () {
				return "";
			},
		},
		// 小数值
		decimal: {
			type: [String, Number],
			default: function () {
				return 100;
			},
		},
		//是否显示MACD
		is_MACD: {
			type: Boolean,
			default: function () {
				return false;
			},
		},
	},
	data() {
		return {
			tabsArr: tabsConfig,
			// 默认产品
			symbol: {
				ticker: 'HBbtcusdt',
				name: 'BTCUSDT',
				description: 'BTCUSDT',
				session: "24x7",
				timezone: "Asia/Shanghai", //默认时区
				minmov: 1,
				// minmov2: 0,
				// pointvalue: 1,
				//设置精度  100表示保留两位小数   1000三位   10000四位
				pricescale: parseInt(this.decimal),
				// fractional: false,
				//设置周期 等于所有时间都是交易时段
				has_intraday: true, //布尔值显示商品是否具有日内（分钟）历史数据
				has_no_volume: false,
				//设置是否支持周月线
				// has_daily: true,
				//设置是否支持周月线
				// has_weekly_and_monthly: true,
				supported_resolutions: ["1", "5", "15", "30", "60", "1D"],
				// seconds_multipliers: ["1S", "5S", "15S"],
				// volume_precision: 0, //整数显示此商品的成交量数字的小数位。0表示只显示整数。1表示保留小数位的1个数字字符
				// data_status: "streaming", //数据状态(streaming(实时),endofday(已收盘),pulsed(脉冲),delayed_streaming(延迟流动中))
			},
			interval: "1", //默认显示规则
			chart: null,
			initdata: {},
			countDate: 0, //累加条数
			startData: 0, //起始条数
			lengsData: 200, //结束长度
			datafeeds: new datafeeds(this),
			onLoadedCallback: null, //初始数据回调
			onRealtimeCallback: null, //websocket数据回调
			lastBarsCache: new Map()
		};
	},
	watch: {
		// line(val) {
		// 	this.changeTabs(val)
		// },
		// symbol() {
		// 	this.changeTabs(this.line)
		// },
	},
	mounted() {
		//事件消息监听
		EventBus.$on('loadChat', (value) => {
			this.loadChart();
		})
		//加载K线图
		this.loadChart();
	},
	//销毁之前
	beforeDestroy() {
		this.removeChart();
	},
	methods: {
		// 默认产品配置
		getSymbol() {
			return this.symbol;
		},

		//加载K线图插件
		loadChart() {
			let self = this;
			this.webSocketInit(); // 初始化websocket
			this.chart = new widget({
				container: self.domId, //`id`属性为指定要包含widget的DOM元素id。
				symbol: self.symbol,
				interval: self.filter(self.interval),
				locale: getLang(), //  语言
				autosize: true,
				fullscreen: false, //是否占用视图所有空间
				preset: "mobile",
				// toolbar_bg: "#1e2235", //背景色
				datafeed: this.datafeeds,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, //时区
				library_path: "/charting_library/", //默认脚本核心文件存储位置
				theme: localStorage.getItem('theme') == "dark" ? "dark" : "light",
				// indicators_file_name: "custom-study(MACD红绿).js",
				// drawings_access: {
				//   type: "black",
				//   tools: [{ name: "Regression Trend" }],
				// },
				//配置项
				...config,
			});
			this.chart.onChartReady(function () {
				//检查是否存在MA
				self.toggleStudies(self.interval);
				// self.createButton(self.tabsArr);
			});
		},
		// 切换产品
		changeSymbol(symbolObj) {
			let self = this;
			console.log('切换产品symbolObj:', symbolObj);
			self.symbol.ticker = symbolObj.symbol;
			self.symbol.name = symbolObj.name;
			self.symbol.description = symbolObj.name;
			self.symbol.session = symbolObj.session;

			// 切换商品
			self.chart.setSymbol(symbolObj.symbol, '1', () => {
				// Your callback function
			});
			//使图表重新请求 datafeed 中的数据。 通常你需要在图表数据发生变化时调用它。 在调用这个函数之前，你应该从 subscribeBars 调用 onResetCacheNeededCallback。
			// self.chart.activeChart().resetData();
		},

		// 切换时间段
		changeTabs(r) {
			let self = this;
			this.interval = r;
			// this.setSymbols();
			// self.chart.chart().setResolution(
			// 	self.filter(self.interval),
			// 	function onReadyCallback() { }
			// );
			console.log('切换时间段', r);

			self.chart.activeChart().setResolution(r);
			self.chart.activeChart().resetData();
		},

		//过滤 时段
		filter(time) {
			return time == "1s" ? "1S" : time;
		},

		// 请求数据,datafees会调用这个方法,把onLoadedCallback回调函数暴漏出来,可以在这里配置,或者暴漏
		getBars(
			symbolInfo,
			resolution,
			periodParams,
			onLoadedCallback
		) {
			this.onLoadedCallback = onLoadedCallback;
			// 加载数据
			const { from, to, firstDataRequest } = periodParams;
			console.log('[getBars]: Method call', symbolInfo, resolution, from, to);
			// var nTime = to - from
			// var day = Math.floor(nTime / 86400); //天数差
			// console.log('[getBars]: Method call', symbolInfo, resolution, from, to, day);

			// 请求参数
			const urlParameters = {
				symbol: symbolInfo.ticker,
				st: from,
				et: to,
				line: this.interval
			}

			try {
				// 这里是请求后台数据,生成历史K线
				klineApi.getKlines(urlParameters).then(response => {
					// console.log('历史K线data', response.data);
					// 这里根据返回数据构造TV需要的数据格式
					let bars = [];
					response.data.forEach(bar => {
						if (bar.date >= from && bar.date < to) {
							bars = [...bars, {
								time: bar.date * 1000, // K线时间必须以毫秒为单位  
								low: bar.low,
								high: bar.high,
								open: bar.open,
								close: bar.close,
								volume: bar.volume,
								resolution: resolution
							}];
						}
					});
					// 首次加载把最后一根k线存到缓存里面,full_name会自动构建交易所:产品代码
					if (firstDataRequest) {
						this.lastBarsCache.set(symbolInfo.full_name, {
							...bars[bars.length - 1],
						});
					}
					console.log(`[getBars]: returned ${bars.length} bar(s)`);
					// 这里调用回调设置k线数据
					onLoadedCallback(bars);
				});
			} catch (error) {
				console.log('[getBars]: Get error', error);
				onErrorCallback(error);
			}
		},

		// 订阅产品的实时行情信息
		subscribeBars(
			symbolInfo,
			resolution,
			onRealtimeCallback,
			subscriberUID,
			onResetCacheNeededCallback // 调用次回调让图表再次请求历史K线数据
		) {
			this.subscribeOnStream(
				symbolInfo,
				resolution,
				onRealtimeCallback,
				subscriberUID,
				onResetCacheNeededCallback,
				this.lastBarsCache.get(symbolInfo.full_name),
			);
			this.onRealtimeCallback = onRealtimeCallback;
			// this.webSocket("get");
		},
		// 取消订阅
		unsubscribeBars(subscriberUID) {
			this.unsubscribeFromStream(subscriberUID)
		},

		//设置品信息(重新获取初始数据/推送数据)
		setSymbols() {
			let self = this;
			self.chart.setSymbol(self.symbol, self.filter(self.interval), function (e) {
				// self.chart.chart().setVisibleRange(self.initdata);
				self.chart.chart().executeActionById("timeScaleReset");
			});

			this.chart.chart().setResolution(
				self.filter(self.interval),
				function onReadyCallback() { }
			);
		},

		//卸载K线
		removeChart() {
			if (this.chart) {
				this.chart.remove();
				this.chart = null;
				this.websockClose(); // 关闭socket连接
			}
		},
		// 创建按钮(这里是时间维度)，并对选中的按钮加上样式
		createButton(buttons) {
			let self = this;
			var thats = this.chart;
			for (var i = 0; i < buttons.length; i++) {
				(function (button) {
					let defaultClass = thats
						.createButton()
						.attr("title", button.label)
						.addClass(
							`mydate ${button.resolution == self.interval ? "s_active" : ""}`
						)
						.text(button.label)
						.on("click", function (e) {
							if (this.className.indexOf("s_active") > -1) {
								// 已经选中
								return false;
							}
							let curent = e.currentTarget.parentNode.parentElement.childNodes;
							for (let index of curent) {
								if (
									index.className.indexOf("my-group") > -1 &&
									index.childNodes[0].className.indexOf("s_active") > -1
								) {
									index.childNodes[0].className = index.childNodes[0].className.replace(
										"s_active",
										""
									);
								} else {
									self.removeClassName(e);
								}
							}
							this.className = `${this.className} s_active`;
							self.changeTabs(button.resolution);
						})
						.parent()
						.addClass(
							"my-group" +
							(button.resolution == self.interval ? " s_active" : "")
						);
				})(buttons[i]);
			}
		},
		//删除 按钮非选中的class
		removeClassName(el) {
			let dom = el.currentTarget.parentNode.parentNode.parentNode.childNodes;
			for (var i = 0; i < dom.length; i++) {
				if (dom[i].hasChildNodes()) {
					if (
						dom[i].childNodes[0].childNodes[0].className.indexOf("s_active") >
						-1
					) {
						dom[i].childNodes[0].childNodes[0].className = dom[
							i
						].childNodes[0].childNodes[0].className.replace("s_active", "");
					}
				}
			}
		},
		/**
		 * 根据状态 显示隐藏 MA
		 * e {string} 时段
		 */
		toggleStudies(e) {
			let self = this;
			if (e == "1s") {
				self.chart
					.activeChart()
					.getAllStudies()
					.forEach((e) => {
						if (e.name == "Moving Average") {
							self.chart.activeChart().removeEntity(e.id);
						}
					});
			} else {
				//检查是否存在MA
				this.getAllStudiesFun();
			}
		},
		//检查是否有 指标MA
		getAllStudiesFun() {
			let self = this;
			let strArr = [];
			self.chart
				.activeChart()
				.getAllStudies()
				.forEach((e) => {
					// console.log(e);
					strArr.push(e.name);
				});
			if (JSON.stringify(strArr).indexOf("Moving Average") == -1) {
				//创建指标
				self.createStudyFun();
			}
		},
		//创建显示指标
		createStudyFun() {
			let self = this;
			try {
				//默认展示MA Cross。移动平均线
				// self.chart.chart().createStudy("MA Cross", false, false, [5, 30]);
				self.chart.chart().createStudy("Moving Average", false, false, ['', 5], {
					"showLabelsOnPriceScale": true,
					"Plot.color": "#F1922E",
					"Plot.linewidth": 0,
				});
				self.chart.chart().createStudy("Moving Average", false, false, ['', 30], {
					"showLabelsOnPriceScale": true,
					"Plot.color": "#119CFE",
					"Plot.linewidth": 0,
				});
				self.chart.chart().createStudy("Moving Average", false, false, ['', 60], {
					"showLabelsOnPriceScale": true,
					"Plot.color": "#AC9FFE",
					"Plot.linewidth": 0,
				});

				if (self.is_MACD) {
					self.chart.chart().createStudy("MACD", !1, !1, [20], null, {}); //MACD
					self.chart
						.chart()
						.createStudy(
							"指数平滑异同移动平均线(MACD_Custom)",
							false,
							false,
							[20],
							null,
							{}
						); //自定义MACD
				}
			} catch (e) {
				console.log(e)
			}
		},
	},
};
</script>
<style lang="scss" scoped>
// /deep/ .van-tabs--line .van-tabs__wrap {
//   height: 100%;
// }
.sTradingviewView {
	height: 100%;
	width: 100%;
}
</style>
